import { render, staticRenderFns } from "./ButtonScrollUp.vue?vue&type=template&id=2408f350"
import script from "./ButtonScrollUp.vue?vue&type=script&lang=js"
export * from "./ButtonScrollUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports